import {serializable} from 'serializr';

export class Employee {

    @serializable employeeNumber: string;
    @serializable firstname: string;
    @serializable lastname: string;
    @serializable email: string;
    @serializable phone: string;
    @serializable countryIsoCode?: string;
    @serializable locale?: string;
    @serializable assistantEmail?: string;
    @serializable managerEmail?: string;
    @serializable regionCode?: string;
    @serializable regionLabel?: string;
    @serializable teamCode?: string;
    @serializable teamLabel?: string;
    @serializable role?: string;
    @serializable speciality?: string;
    @serializable isEforceEmployee ?: boolean;

    setEmployee(employee: any) {
        this.employeeNumber = employee.employeeNumber || '';
        this.email = employee.email || '';
        this.firstname = employee.firstname || '';
        this.lastname = employee.lastname || '';
        this.phone = employee.phone || '';
        this.countryIsoCode = employee.countryIsoCode;
        this.locale = employee.locale;
        this.assistantEmail = employee.assistantEmail;
        this.managerEmail = employee.managerEmail;
        this.isEforceEmployee = employee.isEforceEmployee;
    }
}
